
import { Component, Vue } from "vue-property-decorator";
import ReportsHeader from "@/components/reports/ReportsHeader.vue";
import ReportsTable from "@/components/reports/ReportsTable.vue";
import IconReport from "@/components/common/icon/IconReports.vue";
import WarningModal from "@/components/common/WarningModal.vue";
import { Getter } from "vuex-class";
import { ICountryConfig, IUser } from "@/entities";
import ImportsTable from "@/components/reports/ImportsTable.vue";

@Component({
  name: "reports-page",
  components: {
    ImportsTable,
    ReportsHeader,
    ReportsTable,
    IconReport,
    WarningModal,
  },
})
export default class ReportsPage extends Vue {
  @Getter("getCountryConfig") countryConfig: ICountryConfig | undefined;
  @Getter("getLoggedUser") loggedUser: IUser | undefined;
  currentAction = "reports";
  isReadyImports = false;

  constructor() {
    super();
  }

  async mounted(): Promise<void> {
    if (this.countryConfig?.Reports.ShowWarning) {
      this.$nextTick(() => {
        this.$bvModal.show("warning-modal");
      });
    }
  }

  get isReports(): boolean {
    return this.currentAction === "reports";
  }

  get isImports(): boolean {
    return this.currentAction === "imports";
  }

  get enableImports(): boolean {
    const isAdmin = this.loggedUser?.admin || false;
    return isAdmin && this.isReadyImports;
  }
}
